export default __webpack_public_path__ + "media/images/banners/bnr_betsukai-2675329d778f4d830935aa420106148e.png";